import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import type { StackProps } from "@mui/material/Stack";

export interface ActionStackProps {
  groupTitle: string;
  children: React.ReactNode;

  /**
   * Controls horizontal alignment of stack items.
   * Defaults to "stretch" (recommended for full-width actions).
   */
  alignItems?: StackProps["alignItems"];
}

export default function ActionStack({
  groupTitle,
  children,
  alignItems = "stretch",
}: ActionStackProps) {
  return (
    <Box sx={{ width: "100%" }}>
      <Typography
        variant="h6"
        align="center"
        sx={{ mb: 1, wordBreak: "break-word" }}
      >
        {groupTitle}
      </Typography>

      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
        <Stack spacing={2} alignItems={alignItems}>
          {children}
        </Stack>
      </Paper>
    </Box>
  );
}
